<template>
<v-container>
  Home
</v-container>
</template>

<script>
export default {
  components: {

  }
}
</script>
